import { memo } from 'react'
import MultipleInputSkeleton from 'components/SkeletonView/MultipleInputSkeleton'

const IncomeAllSkeleton = () => <MultipleInputSkeleton count={4} />

export default memo(IncomeAllSkeleton)
